module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/radio_button_checked_UBPE.779ecf48.svg";